const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  isMobile: state => state.app.device === 'mobile'? true:false,
  permission_routes: state => state.permission.routes,
  clickinf: state => state.listdata.clickinf,
  isLogin: state => state.user.token? true : false,
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js